
import { defineComponent } from 'vue'

export default defineComponent({
  name: "Checkbox",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: [
    'update:modelValue'
  ],
  methods: {
    toggle(value: boolean): void {
      this.$emit('update:modelValue', value)
    }
  }
});
